import React, { useState, useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import configData from '../../temp/config';
import './top-header.css'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';

const HeaderLogo = (props) => {
  const [componentData, setComponentData] = useState({})

  useEffect(() => {
    setComponentData(props.fields);
    // checkDropDown();
  }, [])

    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //----------------------------------------------

  return (
    // <div className="period-wrap">
      <header className='top-header-kc'>
        {componentData.image &&
          <img src={`${configData.sitecoreApiHost}${componentData.image.value.src}`} alt="" />}
      </header>
    // </div>
  )
};

export default HeaderLogo;
